import { computePosition, offset, flip, shift } from '@floating-ui/dom';

if (document.querySelector('.wapf-field-image-swatch .apf-pick-box img')) {

    const floating = document.createElement('div');
    floating.id = 'floating';
    floating.className = 'floating-preview';
    document.body.appendChild(floating);

    let isActive = false;

    document.querySelectorAll('.wapf-field-image-swatch.visual-cover-color .apf-pick-box img, .wapf-field-image-swatch.visual-text-color .apf-pick-box img').forEach(thumb => {
        thumb.addEventListener('mouseenter', () => {
            const label = thumb.parentElement.parentElement.querySelector('input.wapf-input').getAttribute('data-wapf-label');
            const largeImg = thumb.src;
            floating.innerHTML = `<img src="${largeImg}" alt="Preview"><span class="text-center text18 block">${label}</span>`;
            floating.style.display = 'block';
            isActive = true;
        });

        thumb.addEventListener('mouseleave', () => {
            isActive = false;
            floating.style.display = 'none';
        });
    });

    document.addEventListener('mousemove', ({ clientX, clientY }) => {
        if (!isActive) return;

        const virtualEl = {
            getBoundingClientRect() {
                return {
                    width: 0,
                    height: 0,
                    x: clientX,
                    y: clientY,
                    left: clientX,
                    right: clientX,
                    top: clientY,
                    bottom: clientY,
                    toJSON() {}
                };
            }
        };

        computePosition(virtualEl, floating, {
            placement: 'left-start',
            middleware: [offset(10), flip(), shift()]
        }).then(({ x, y }) => {
            Object.assign(floating.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    });
}